import { useSelector } from 'react-redux'
import { ImportExportTableContent } from './ImportExportTableContent'
import { selectTab } from './slice'

export const Table = () => {
  const tab = useSelector(selectTab)

  return <ImportExportTableContent tab={tab} />
}
